/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { TableName } from "../../constants/table";
import {
  getAllEntities,
  getFilteredEntities,
  getEntity,
  deleteEntity,
} from "../services/api-service";
import { ITenant } from "../../models/tenant";

const tableName = TableName.Users;

export const fetchUsers = async ({
  tenantId,
  userRole,
}: {
  tenantId: string;
  userRole?: string;
}) => {
  let users;
  if (userRole === "SuperAdmin") {
    users = await getAllEntities(tableName);
  } else {
    users = await getFilteredEntities(tableName, tenantId);
  }
  const tenants = await getAllEntities(TableName.Tenant) as ITenant[];

  const data = await Promise.all(
    users.map(async (user: any, index: number) => {
      const tenantName = tenants.find(
        (e) =>
          e.PartitionKey?.toLowerCase() === user.PartitionKey?.toLowerCase()
      )?.RowKey;

      const userEntity = await getEntity(
        tableName,
        user.PartitionKey,
        user.RowKey
      );
      const role = userEntity?.Role;

      return { ...user, id: index, tenantName, role };
    })
  );

  return data;
};

export const useFetchUsers = ({
  tenantId,
  userRole,
}: {
  tenantId: string;
  userRole?: string;
}) =>
  useQuery({
    queryKey: ["fetchUsers", userRole, tenantId],
    queryFn: async () => fetchUsers({ tenantId, userRole }),
  });

export const deleteUser = async (payload: {
  PartitionKey: string;
  RowKey: string;
}) => {
  const { PartitionKey, RowKey } = payload;
  await deleteEntity(tableName, PartitionKey, RowKey);
};
